import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Select , MenuItem } from "@mui/material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import DriverApi from "Services/Driver"

const Cashoutrecords = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination
  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [statusMap, setStatusMap] = useState({});
  //Modals

  // Get userWallet list api
  const getcashoutrecords = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       // console.log('cashout-records-->',res?.data?.data?.data);
        const cashoutData = res?.data?.data?.data || [];

        setRow(cashoutData);

        // Build statusMap from fetched data
        const newStatusMap = {};
        cashoutData.forEach((item) => {
          newStatusMap[item._id] = item.status;
        });
        setStatusMap(newStatusMap);

      } else {
        setRow([]);
        setStatusMap({});
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi
      .getdriverscashoutrecords({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

    const getAllcashoutrecords = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       // console.log('cashout-records-->',res?.data?.data?.data);
        const cashoutData = res?.data?.data?.data || [];
        setbulkrow(cashoutData);

      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi
      .getdriverscashoutrecords({ page:1, limit: "unlimited"  })
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getcashoutrecords();
    getAllcashoutrecords();
  }, [getcashoutrecords]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All CahoutrecordsList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15,15,15,15,15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("User Name", columnWidths[1]),
        padText("Email", columnWidths[2]),
        padText("Mobile", columnWidths[3]),
        padText("Status", columnWidths[4]),
        padText("Earned amount", columnWidths[5]),
        padText("Platform fee", columnWidths[6]),
        padText("Cashout amount", columnWidths[7]),
        padText("Updated At", columnWidths[8])
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.username, columnWidths[1]),
            padText(row.email, columnWidths[2]),
            padText(row.mobile, columnWidths[3]),
            padText(row.status, columnWidths[4]),
            padText(row.amount_earned, columnWidths[5]),
            padText(row.platform_fee, columnWidths[6]),
            padText(row.cashout_amount, columnWidths[7]),
            padText(row.updatedAt, columnWidths[8])

          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "CashoutrecordsList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "CashoutrecordsList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.username,
      row.email,
      row.mobile,
      row.status,  
      row.amount_earned, 
      row.platform_fee,
      row.cashout_amount,
      row.updatedAt
    ]);
    doc.autoTable({
      head: [["S.NO","User Name","Email","Mobile","Status","Earned amount", "Platform fee","Cashout amount","Updated At"]],
      body: tableData,
    });
    doc.save("CashoutrecordsList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

function formatDate(inputDate) {
  if (!inputDate) return "--";

  // Handle MongoDB date object: { $date: "..." }
  const dateValue = inputDate?.$date || inputDate;

  if (!dateValue) return "--";

  // Fallback timezone if undefined
  const tz = timezone || "UTC";

  // Validate date before formatting
  if (!moment(dateValue).isValid()) return "--";

  return moment(dateValue).tz(tz).format("YYYY-MM-DD hh:mm A");
};

const dataRows = _.map(
  (row || []).filter(data => data?.driver_details?.user_name && data?.driver_details?.email && data?.status === "REJECTED"), // Filter out rows with empty or undefined username
  (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    username: data?.driver_details?.user_name,
    email: data?.driver_details?.email,
    mobile: data?.driver_details?.countryCode+" "+data?.driver_details?.mobileNumber,
    status: data?.status,
    amount_earned: (data?.amount_earned ?? 0).toFixed(2),
    platform_fee: (data?.platform_fee ?? 0).toFixed(2),
    cashout_amount: (data?.cashout_amount ?? 0).toFixed(2),
    cashout_usertype: data?.cashout_usertype,
    updatedAt:formatDate(data?.updatedAt),
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "User Name":row.username,
    "Email":row.email,
    "Mobile": row.mobile,
    "Status": row.status,
    "Earned amount": row.amount_earned,
    "Platform fee": row.platform_fee,
    "Cashout amount": row.cashout_amount,
    "Updated At": row.updatedAt,
  }));

  const bulkdataRows =  _.map(_.orderBy(
    (bulkrow || []).filter(data => data?.driver_details?.user_name && data?.driver_details?.email && data?.status === "REJECTED" ),
    ['createdAt'],['asc'] // or 'desc' for latest first
  ),(data, index) => ({
   sno: calculateSno(page, pageSize, index),
    username: data?.driver_details?.user_name,
    email: data?.driver_details?.email,
    mobile: data?.driver_details?.countryCode+" "+data?.driver_details?.mobileNumber,
    status: data?.status,
    amount_earned: (data?.amount_earned ?? 0).toFixed(2),
    platform_fee: (data?.platform_fee ?? 0).toFixed(2),
    cashout_amount: (data?.cashout_amount ?? 0).toFixed(2),
    cashout_usertype: data?.cashout_usertype,
    updatedAt:formatDate(data?.updatedAt),
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "User Name":row.username,
    "Email":row.email,
    "Mobile": row.mobile,
    "Status": row.status,
    "Earned amount": row.amount_earned,
    "Platform fee": row.platform_fee,
    "Cashout amount": row.cashout_amount,
    "Updated At": row.updatedAt,
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "username",
      headerName: "Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
          <Typography variant="body2"  
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontWeight:"bold",
            cursor: "pointer",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}>{params?.row?.username}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
      
    },
{
  field: "status",
  headerName: "Status",
  flex: 1,
  sortable: true,
  renderCell: (params) => {
    const rowId = params.row.row._id;
    const currentStatus = statusMap[rowId] || "PENDING";

    const getColor = (status) => {
      switch (status) {
        case "PAID":
          return "#04a571";
        case "REJECTED":
          return "#cb0202"; // mild red
        case "PENDING":
        default:
          return "#ed6c02"; // orange (pending)
      }
    };

    return (
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: getColor(currentStatus),
          textTransform: "capitalize",
        }}
      >
        {currentStatus === "PAID" ? "APPROVED" : currentStatus}
      </Typography>
    );
  },
},
    {
      field: "cashout_amount",
      headerName: "Cashout Amount",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.cashout_amount+" "+CUSTOM_CONSTANTS.BASE_CURRENCY}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.updatedAt}</Typography>
            </div>
          </>
        );
      },
    },      
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
      <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
      <Button variant="contained" onClick={handleDownloadAll}>
      Download ALL
      </Button>
      </Grid>  
      </Grid>

        <Grid container className={classes.walletdetails}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default Cashoutrecords;
